var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGlobalCitizenship(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 32.647,
    height: 34.53,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_global_citizenship",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(337.51 223.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212-2",
    "data-name": "Group 212",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21853",
    "data-name": "Path 21853",
    d: "M.893,14.758A14.528,14.528,0,1,1,15.418,29.29,14.53,14.53,0,0,1,.893,14.758",
    transform: "translate(1.952 0.497)",
    fill: "#b7edae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21854",
    "data-name": "Path 21854",
    d: "M2.117,14.031A12.578,12.578,0,1,1,14.692,26.613,12.577,12.577,0,0,1,2.117,14.031",
    transform: "translate(4.628 3.177)",
    fill: "#6eba63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21855",
    "data-name": "Path 21855",
    d: "M29.364,22.557,27.972,21.8A13.691,13.691,0,1,0,2.245,15.274a13.517,13.517,0,0,0,1.147,5.493l-1.45.637a15.1,15.1,0,0,1-1.284-6.13,15.275,15.275,0,1,1,28.706,7.283",
    transform: "translate(1.438 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21856",
    "data-name": "Path 21856",
    d: "M18.438,21.617l-1.539-.37a25.758,25.758,0,0,0,.672-5.971c0-7.423-3-13.693-6.544-13.693S4.486,7.853,4.486,15.277a27.9,27.9,0,0,0,.143,2.839l-1.574.162a29.257,29.257,0,0,1-.153-3C2.9,6.71,6.471,0,11.027,0s8.124,6.71,8.124,15.277a27.382,27.382,0,0,1-.714,6.34",
    transform: "translate(6.346 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21857",
    "data-name": "Path 21857",
    d: "M12.446,6.332a15.246,15.246,0,0,1-10.192-3.9L3.309,1.254a13.662,13.662,0,0,0,9.137,3.5,13.677,13.677,0,0,0,8.87-3.262l1.029,1.207a15.293,15.293,0,0,1-9.9,3.638",
    transform: "translate(4.927 2.742)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1093",
    "data-name": "Rectangle 1093",
    width: 28.967,
    height: 1.583,
    transform: "translate(2.89 14.484)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 1.583,
    height: 17.736,
    transform: "translate(16.58 0.793)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21858",
    "data-name": "Path 21858",
    d: "M24.927,11.808c-4.069,2.526-5.388,3.307-8.9,1.908s-4.492-1.8-4.126-2.7c.583-1.408,4.327.182,6.1.586,2.995.682,4.406-2.59.526-3.549s-5.107-1.625-8.163-1.2C6.3,7.415.334,12.168.334,12.168l4,5.983a16.823,16.823,0,0,1,4.833-.793c2.526,0,4.91,1.682,8.417,1.682,4.349,0,7.162-3.081,9.44-4.425,3.087-1.826,1.966-5.333-2.1-2.807",
    transform: "translate(0.73 14.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21859",
    "data-name": "Path 21859",
    d: "M26.122,12.429c.061-4.773-2.7-.806-6.56.462-2.851.933-5.948,0-6.362-.5C10.243,11.2,9.411,10.8,9.752,9.966c.58-1.408,4.327.178,6.1.586,2.058.468,3.371-.937,2.721-2.17-3-.79-4.279-1.287-7.009-.908C7.5,8.036,1.529,12.789,1.529,12.789l2.558,3.82A15.517,15.517,0,0,1,7.018,16.3c2.523,0,4.906,1.682,8.414,1.682,4.349,0,7.162-3.081,9.443-4.425a4.193,4.193,0,0,0,1.306-1.166c-.022.013-.061.061-.061.035",
    transform: "translate(3.342 16.057)",
    fill: "#ffd0cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21860",
    "data-name": "Path 21860",
    d: "M7.38,9.629a2.014,2.014,0,0,0,1.8-1.058c-.666.411-1.258.765-1.8,1.058",
    transform: "translate(16.133 18.736)",
    fill: "#946290"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21861",
    "data-name": "Path 21861",
    d: "M18.319,20.373a16.488,16.488,0,0,1-5.142-.981,11.24,11.24,0,0,0-3.275-.7,16.023,16.023,0,0,0-4.575.752l-.577.2L0,12.545l.57-.456c.252-.2,6.19-4.894,10.425-5.477a13.527,13.527,0,0,1,6.3.653c.628.169,1.332.36,2.157.564,2.409.6,3.2,2.077,2.912,3.285-.293,1.227-1.72,2.272-3.8,1.8-.411-.092-.927-.249-1.481-.417-.9-.271-3.262-.984-3.7-.65a19.8,19.8,0,0,0,3.673,1.673c3.173,1.265,4.234.609,8.185-1.845,2.2-1.364,3.489-1.042,4.065-.726a1.939,1.939,0,0,1,1.013,1.72,3.888,3.888,0,0,1-2.157,3.164c-.516.306-1.09.726-1.695,1.169-2.045,1.5-4.591,3.368-8.147,3.368M9.9,17.108a12.5,12.5,0,0,1,3.747.774,15,15,0,0,0,4.671.908c3.039,0,5.257-1.625,7.21-3.059.64-.468,1.243-.911,1.829-1.258A2.394,2.394,0,0,0,28.735,12.7a.363.363,0,0,0-.188-.36c-.335-.185-1.188-.118-2.472.682-4.024,2.5-5.69,3.533-9.606,1.969-3.065-1.227-4.212-1.689-4.585-2.565a1.472,1.472,0,0,1,.022-1.166c.723-1.762,3.447-.937,5.633-.274.519.156,1,.3,1.38.389,1.134.258,1.81-.22,1.908-.628.1-.433-.4-1.051-1.752-1.383-.838-.207-1.552-.4-2.189-.57a12.01,12.01,0,0,0-5.674-.615c-3.1.427-7.509,3.54-9.077,4.706L5.4,17.767a17.294,17.294,0,0,1,4.5-.66",
    transform: "translate(0 14.157)",
    fill: "#404040"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobalCitizenship);
export default __webpack_public_path__ + "static/media/ic_global_citizenship.b68b7c0e51a2c069bb542a5723784def.svg";
export { ForwardRef as ReactComponent };